import { defineStore } from 'pinia'
import ProductService from '@/services/ProductService'

// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const useProductsStore = defineStore('products', {
  state: () => ({
    currentProducts: [],
    productCategories: [],
    currentSubcategories: [],
    searchedProducts: [],
    searchedVariants: [],
  }),
  getters: {
    getCurrentProducts() {
      return this.currentProducts
    },
  },
  actions: {
    async searchProducts(search) {
      const response = await ProductService.searchProducts(search)
      if (response.status.value === 'success')
        this.searchedProducts = response.data.value
    },

    async searchVariants(search) {
      const response = await ProductService.searchVariants(search)
      if (response.status.value === 'success')
        this.searchedVariants = response.data.value
    },

    clearVariants() {
      this.searchedVariants = []
    },

    async fetchProductCategories() {
      if (!this.productCategories || this.productCategories.length === 0) {
        const response = await ProductService.getCategories()

        this.productCategories = [{
          id: '1',
          children: [],
          slug: 'garden',
          title: 'garden',
        }, {
          id: '2',
          children: [],
          slug: 'deco',
          title: 'deco',
        }, {
          id: '3',
          children: [],
          slug: 'balcony',
          title: 'balcony',
        }]

        this.productCategories.forEach((group) => {
          group.children = JSON.parse(JSON.stringify(response.data.value.filter(category => category?.groups?.includes(group.title))))
          group.children.forEach((child) => {
            // console.log(child.title)
            // console.log(...child?.children?.filter(childCategory => childCategory?.groups?.includes(group.title)))
            child.children = JSON.parse(JSON.stringify(child?.children?.filter(childCategory => childCategory?.groups?.includes(group.title))))
          },
          )
        })

        return this.productCategories
      }
    },
    fetchAllProducts() {
      const fetchedProducts = ProductService.all()
      if (fetchedProducts)
        this.currentProducts = fetchedProducts
      // let currentSeller = SellersApiService
      // .fetchCurrentSeller(payload.postcode)
      // .then((response) => {
      //   commit('SET_CURRENT_SELLER', response)
      // })
    },

    async fetchProductsByCategory(group) {
      const fetchedProducts = await ProductService.getProductsOfGroup(group)
      if (fetchedProducts.status.value === 'success')
        this.currentProducts = fetchedProducts.data.value
    },

    async fetchProductsByCategoryAndType(category, type) {
      let fetchedProducts = null

      const groupString = this.productCategories?.find(x => x.slug === category).title
      const categoryId = this.productCategories?.find(x => x.slug === category).children.find(x => x.slug === type).id

      if (category && type)
        fetchedProducts = await ProductService.getProductsOfCategory(categoryId, groupString)
      else
        fetchedProducts = await ProductService.all()

      if (fetchedProducts.status.value === 'success')
        this.currentProducts = fetchedProducts.data.value
    },
  },
})
